module.exports = __webpack_public_path__ + "img/pos-indonesia.98653bba.svg";